<div class="p-base flex flex-col gap-base border-b border-ui-separator bg-gray-50">
  <div class="flex items-center justify-between">
    <div class="text-sm leading-sm font-semibold text-txt-secondary">
      @if (singleSelection) {
        Select Week
      } @else {
        Select Weeks
      }
    </div>
    @if (!singleSelection) {
      <lla-button class="md:hidden" variant="ghost" size="medium-shrink" (click)="clearAll()">
        Clear all
      </lla-button>
    } @else {
      <lla-button
        class="md:hidden"
        variant="ghost"
        size="medium-shrink"
        icon="close"
        (click)="canceld.emit()"
      ></lla-button>
    }
  </div>

  @if (!singleSelection) {
    <div class="flex flex-row gap-sm items-center w-full overflow-auto no-scrollbar">
      @for (item of periodItems; track item.value) {
        <lla-pill
          extraClass="w-max min-w-max"
          [selected]="selectedPeriod === item.value"
          [label]="item.label"
          size="s"
          (click)="setSelectedPeriod(item)"
        >
        </lla-pill>
      }
    </div>
  }
</div>

<div #weekSelectorContent class="p-base flex-1 overflow-auto flex flex-col gap-base md:max-h-[350px]">
  @for (item of allWeeksGrouped | keyvalue; track item.key; let lastYear = $last) {
    <div class="flex items-center gap-sm">
      <div class="title-line"></div>
      <div class="text-sm leading-sm text-primary">{{ item.key }}</div>
      <div class="title-line"></div>
    </div>

    <div class="grid grid-cols-2 md:grid-cols-4 gap-sm">
      @for (week of item.value; track week.value; let lastWeek = $last) {
        <div
          [id]="'week-item-' + week.value"
          class="week-item"
          [ngClass]="{
            italic: lastWeek && lastYear,
            '!bg-primary !border-primary !text-white': selectedWeeksValue.includes(week.value),
            '!bg-primary/30 !border-primary/50':
              inRangeWeeks.includes(week.value) && !selectedWeeksValue.includes(week.value)
          }"
          (click)="selectWeek(week.value)"
          (mouseenter)="onWeekMouseEnter(week.value, $event)"
          (mouseleave)="onWeekMouseLeave()"
        >
          {{ week.label }}
        </div>
      }
    </div>
  }
</div>

@if (!singleSelection) {
  <div class="hidden md:flex items-center justify-between p-base border-t border-ui-separator">
    <lla-button variant="ghost" size="medium-shrink" (click)="clearAll()"> Clear all </lla-button>
    <div class="flex items-center">
      <lla-button class="mr-2xl" variant="ghost" size="medium-shrink" (click)="canceld.emit()">
        Cancel
      </lla-button>
      <lla-button
        [disabled]="selectedWeeksValue.length === 0"
        variant="ghost"
        size="medium-shrink"
        extraBtnClass="!text-primary"
        (click)="applySelection()"
      >
        Apply

        @if (selectedWeeksValue.length > 0) {
          {{ selectedWeeksValue.length }} selection{{ selectedWeeksValue.length > 1 ? 's' : '' }}
        }
      </lla-button>
    </div>
  </div>

  <div class="px-base flex md:hidden flex-col gap-xs">
    <lla-button [disabled]="selectedWeeksValue.length === 0" size="medium" (click)="applySelection()">
      Apply

      @if (selectedWeeksValue.length > 0) {
        {{ selectedWeeksValue.length }} selection{{ selectedWeeksValue.length > 1 ? 's' : '' }}
      }
    </lla-button>
    <lla-button variant="ghost" size="medium" extraBtnClass="!text-primary" (click)="canceld.emit()">
      Cancel
    </lla-button>
  </div>
}
